import { render, staticRenderFns } from "./Roads.vue?vue&type=template&id=d645ae7c&scoped=true"
import script from "./Roads.vue?vue&type=script&lang=js"
export * from "./Roads.vue?vue&type=script&lang=js"
import style0 from "./Roads.vue?vue&type=style&index=0&id=d645ae7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d645ae7c",
  null
  
)

export default component.exports